import { Injectable } from '@angular/core';
//@ts-ignore
import { jsonPath } from 'src/js/jsonpath';
import * as $ from 'jquery';
import { Subject, Subscription } from 'rxjs';
import { FdrsVersionCheckerService } from './fdrs-version-checker.service';
import { SbdoApiService } from './sbdo-api.service';
import { ApifirstService } from './apifirst.service';
import { Router } from '@angular/router';
import { Applicationqueue } from './applicationqueue';
import * as environmentUrl from 'src/environments/environment';

//@ts-ignore
import * as dialogHelper from '../../assets/js/FDT-EU/dialogHelper';
//declare function showModalMessage(): any;



@Injectable({
  providedIn: 'root'
})
export class RpcClientService {
  public baseUrl = environmentUrl.environment.baseUrl;
  public baseUri = environmentUrl.environment.baseUri;
  previousScreenSubscription: Subscription = new Subscription;
  locale = ''
  vin = ''
  userName = ''
  public secureToken = ''
  public token: any;
  public res: any;
  public invinnumber = ''
  public language = ''
  public countryCode = ''
  public sessionId: any
  public qidRes: any;
  public queueId = ''
  public userType: any;
  public dealerCode = '';
  public selectedAppId: string = '';
  authToken = ''
  hostAddr = "127.0.0.1";
  webSocket: any;
  messageCallbackFunctions: any = {};
  nextMessageId = 0;
  loggedIn = false;
  user = '';
  public repairObj: any;
  public postRepairObj: any;
  public candidateType: string = '';
  deferredConnState = $.Deferred();
  deferredLogState = $.Deferred();
  deferredloginState = $.Deferred();
  deferredAppReady = $.Deferred();
  deferredFDTRequest = $.Deferred();
  deferredFDTScreenNotification = $.Deferred();
  deferredApplicationQueue = $.Deferred();
  deferredGetVinResult = $.Deferred();
  country = '';
  public captureOtxStateChange: any = [{}];
  fdtScreennotificationTypes = ['close_screen', 'highlight_screen', 'open_screen', 'variable_value_changed'];
  connectionStatus = {
    CONNECTING: 0,
    CONNECTED: 1,
    FAILED: 2,
    CLOSED: 3,
    FAILED_RETRY: 4,
    INCOMPATIBLE: 5
  };
  status = {
    SUCCESS: "success",
    FAILURE: "failed",
    STALL: "stall"
  };
  errorCode = {
    cookieExpired: -32007
  };
  errorState = {
    ANOTHER_APP_ACTIVE: "ANOTHER_APP_ACTIVE",
    ABORTED: "ABORTED"
  };
  minPortRange = 10990;
  maxPortRange = 10994;

  //constants
  FDT_PORT = 'FDTPort';
  CONNECTION_STATE = 'connectionState';
  AUTH_TOKEN = 'AuthToken';
  KEEP_ALIVE_INTERVAL = 3 * 60000;


  keepAliveHandler: any = undefined;

  Another_App_Active: boolean = false;
  Start_Application_Params: any;


  // dialogHelper = new dialogHelper(); //check later ???
  queue: any;
  tokenObj: any;
  otxStatusRes: any;
  userId: any;
  _networkResult$: Subject<any> = new Subject<any>();


  // network test updates
  network_test_update = {
    percentage: 0,
    current_module: null,

    notification: {
      listeners: [],

      registerListener: function (obj: any) {
        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
        this.listeners.push(obj);
      },

      unregisterAllListeners: function () {
        this.listeners = [];
      },

      notifyListeners: function () {
        this.listeners.forEach(function (element) {
          (element as any).update();
        });
      }
    },

    setPercentage: function (percentage: any) {
      this.percentage = percentage;
      this.notification.notifyListeners();
    },

    setCurrentModule: function (module: any) {
      this.current_module = module;
      this.notification.notifyListeners();
    },

    resetProgress: function () {
      this.percentage = 0;
      this.current_module = null;
    }
  };

  constructor(private apiService: ApifirstService,
    private fdrsVersionCheckerService: FdrsVersionCheckerService,
    private sbdoApiService: SbdoApiService, private service: ApifirstService, private route: Router
  ) {
  }

  /*
      Initialize the web socket connection to FDRS
  */
  initializeWebSocket() {
    let FDRSUserType: any;
    this._resetLocalStorage();
    this.loggedIn = false;
    this.token = localStorage.getItem("token")
    this.service.tokenObj.subscribe((data) => {
      this.tokenObj = data
      this.language = this.tokenObj.language
      this.country = this.tokenObj.country
      this.vin = this.tokenObj.vin
      if (this.tokenObj.userType == 'FORD_INTERNAL') {
        FDRSUserType = 'STAFF';
      } else if (this.tokenObj.userType == 'PTS_DEALER') {
        FDRSUserType = 'DEALERS'
      } else if (this.tokenObj.userType == 'PTS_AFTERMARKET') {
        FDRSUserType = 'RETAIL';
      }
      this.dealerCode = this.tokenObj.dealerCode;
      this.userType = this.tokenObj.userType
      console.log("fdrsUserType:", this.userType);
      this.locale = this.language.toLowerCase() + "_" + this.country;
      this.userName = this.tokenObj.username
      console.log("Username in initializing Websocket connection", this.userName);
      const fdspTokenReqDto = {
        userName: this.tokenObj.username
      };
      this.service.secureToken(this.dealerCode, this.userType, this.language, this.country, fdspTokenReqDto).subscribe(data => {
        this.secureToken = data.secure_token;
        this.authToken = '?ETIS-credential=' + this.token + '&origin=https%3A%2F%2F' + this.baseUri + '&locale=' + this.locale + '&vin=' + this.vin + '&userType=' + FDRSUserType + '&userName=' + fdspTokenReqDto['userName']+ "&secure_token=" + this.secureToken;
        this._setupWebsocketPort();
      })
    })

    this.service.userId.subscribe((data) => {
      this.userId = data;
    })
    this.deferredConnState = $.Deferred();
    return this.deferredConnState.promise();
  };

  //Check Connection Status:

  checkWebSocketConnectionStatus() {
    this.checkSetupWebSocketPort()
  }

  //Set up WebSocket Port

  checkSetupWebSocketPort() {
    console.log("set websocket starting..");
    var storedPort = window.localStorage.getItem(this.FDT_PORT);
    var that = this;

    if (storedPort != null) {
      this.checkTryWebSocketPort(storedPort, (failedPort: any) => {
        that.checkBroadCast(failedPort);
      });
    }
    else {
      this.checkBroadCast(null);
    }

  }

  checkTryWebSocketPort(port: any, failCallback: any) {
    var url = "ws://" + this.hostAddr + ":" + port;
    //console.log("Trying to connect to FDRS on URL:" + url);

    url = url + this.authToken;

    var socket: any = null;

    try {
      socket = new WebSocket(url);
    }
    catch (exception) {
      console.log('exception occured during socket object creation ', exception);
      //return false; ??? check later
    }

    socket.onmessage = (message: any) => {
      var that = this;
      that._handleMessage(message);
    };
    socket.onopen = () => {
      var that = this;
      console.log("Connection is made");
      // this.apiService.isFDRSConnection.next(true)
      that.webSocket = socket;
      console.log('socket url ' + url);
      this.service.fdrsConnectionIndicator.next('show');
      this.service.isShowFDRSLoader.next(false);
      if (localStorage.getItem("component") == 'fromStartup')
        this.service.getWebsocketStatusonStartUpComp.next('true')
      else if (localStorage.getItem("component") == 'fromDiagnostic' || localStorage.getItem("component") == 'fromRepair' || localStorage.getItem("component") == 'fromPostRepair') {
        this.service.getFDRSStatusInDiagnostic.next('true')
      } else {
        this.service.getWebsocketStatus.next('true')
      }
    };
    socket.onerror = () => {
      var that = this;
      var wsPort = that._getPortFromUrl(socket.url);
      if (failCallback) {
        failCallback(wsPort);
      }
    };
  }

  checkBroadCast(excludePort: any) {
    var ports = this._createPortArray(excludePort);
    var that = this;
    ports.forEach((port) => {
      that.checkTryWebSocketPort(port, (failedPort: any) => {
        that.checkRemovePortArrayValues(ports, failedPort);
        if (ports.length == 0) {
          if (localStorage.getItem("component") == 'fromStartup') {
            this.service.getWebsocketStatusonStartUpComp.next('false')
          } else if (localStorage.getItem("component") == 'fromDiagnostic' || localStorage.getItem("component") == 'fromRepair' || localStorage.getItem("component") == 'fromPostRepair') {
            this.service.getFDRSStatusInDiagnostic.next('false')
          } else {
            this.service.getWebsocketStatus.next('false')
          }
          this.service.fdrsConnectionIndicator.next('hide');
        }
      });
    });
  }

  checkRemovePortArrayValues(array: any, value: any) {
    var index = array.indexOf(value);

    if (index > -1) {
      array.splice(index, 1);
    }
  }

  /**
    * Tries to establish port for websocket communication
    */
  _setupWebsocketPort() {
    console.log("set websocket starting..");
    var storedPort = window.localStorage.getItem(this.FDT_PORT);
    var that = this;

    if (storedPort != null) {
      this._tryPortRetryForWebsocket(storedPort, (failedPort: any) => {
        that._broadcastWebsocket(failedPort);
      });
    }
    else {
      this._broadcastWebsocket(null);
    }
  }

  /**
   * Tries to establish connection on all available ports
   *
   * @param excludePort port to exclude from broadcast
   * @private
   */
  _broadcastWebsocket(excludePort: any) {
    var ports = this._createPortArray(excludePort);
    var that = this;
    ports.forEach((port) => {
      that._tryPortRetryForWebsocket(port, (failedPort: any) => {
        that._removeArrayValue(ports, failedPort);

        if (ports.length == 0) {
          that._setConnectionStatus(that.connectionStatus.FAILED);
          that.deferredConnState.notify(that.connectionStatus.FAILED);
        }
      });
    });
  }

  /**
   * Removes element from array
   *
   * @param array
   * @param value
   * @private
   */
  _removeArrayValue(array: any, value: any) {
    var index = array.indexOf(value);

    if (index > -1) {
      array.splice(index, 1);
    }
  }

  /**
   * Creates array of ports base on range values
   *
   * @param excludePort port to be excluded from range
   * @returns {Array}
   * @private
   */
  _createPortArray(excludePort: any) {
    var iport, ports = [];

    for (iport = this.minPortRange; iport <= this.maxPortRange; iport++) {
      if (iport !== excludePort) {
        ports.push(iport);
      }
    }

    return ports;
  }

  /*
  function to make a webscoket connection on given port
  */
  _tryPortRetryForWebsocket(port: any, failCallback: any) {
    this._setConnectionStatus(this.connectionStatus.CONNECTING);
    var url = "ws://" + this.hostAddr + ":" + port;
    url = url + this.authToken;

    var socket: any = null;

    try {
      socket = new WebSocket(url);
    }
    catch (exception) {
      //console.log('exception occured during socket object creation ', exception);
      //return false; ??? check later
    }

    socket.onmessage = (message: any) => {
      var that = this;
      that._handleMessage(message);
    };
    socket.onopen = () => {
      var that = this;
      console.log("Connection is made");
      // this.apiService.isFDRSConnection.next(true)
      that.webSocket = socket;
      console.log('socket url ' + url);
      var wsPort = that._getPortFromUrl(socket.url);
      //setting the port in local storage

      window.localStorage.setItem(that.FDT_PORT, wsPort.toString());  // ??? check later
      that._setConnectionStatus(that.connectionStatus.CONNECTED);
      that.deferredConnState.notify(that.connectionStatus.CONNECTED);
      //that.keepAliveHandler = setInterval(that.keepAlive, that.KEEP_ALIVE_INTERVAL);
      that.setKeepAliveInterval();

      socket.onerror = function () {
        if (that.getConnectionStatus() === that.connectionStatus.CONNECTED) {
          that.deferredConnState.notify(that.connectionStatus.CLOSED);
          //console.log("FDRS connection dropped from port: " + wsPort);
          close();
        }
      };
    };
    socket.onerror = () => {
      var that = this;
      var wsPort = that._getPortFromUrl(socket.url);
      console.log("Could not connect to FDRS on port: " + wsPort);
      this.service.isShowFDRSLoader.next(false);
      that.deferredConnState.notify(that.connectionStatus.FAILED_RETRY);

      if (failCallback) {
        failCallback(wsPort);
      }
    };
  }

  /*
   function to process the websocket response
   */
  _handleMessage(message: any) {
    try {
      var json = JSON.parse(message.data);
      var responseId = json.id;
      //var error = jsonPath(json, "$.error")[0];  ??? - check later
      var error = jsonPath(json, "$.error");

      if (responseId == null) {
        //            if (error != null)  // ??? check later
        if (error) {
          console.log('error occured during handling message');
          //it is returned as null if FDRS cannot desrialize the request
          // check later ???
          //this._handleError(0,  error.code, error.message);
        }
        else {
          //this looks like a notification from FDT
          this._handleNotification(json);
        }
      }
      /// ??? - uncomment later
      else {
        console.log('response id is present in handle message 2', responseId);
        var callbackFunction = this._getMessageCallbackFunction(responseId);
        if (!callbackFunction) {
          //this looks like an fdrs request
          console.log("handle FDT Req:");
          this._handleFDTRequest(json); //??? - check functionality later
        }
        else {
          //this is a response to etis made request
          var msgType = this._getMessageType(responseId);
          var response: any = { "status": null, "responseData": null };

          //if (error != null) ??? - check later
          if (error) {
            if (typeof error === "string") {
              error = JSON.parse(error);
            }

            //this._handleError(msgType,  error.code, error.message); ??? check later

            //set response
            response.status = this.status.FAILURE;
            // ???
            //response.responseData = {"errorCode":error.code, "errorMsg":error.message};
            response.responseData = { "errorCode": error, "errorMsg": error };
          }
          else {
            //set response
            response.status = this.status.SUCCESS;
            response.responseData = json.result;
          }
          callbackFunction(response);
        }
      }
    }
    catch (excp) {
      console.error(excp);
    }
  }


  /**
   * function to broadcast a request recieved event
   * for FDRS scripts to handle
   */
  _handleFDTRequest(request: any) {
    this.deferredFDTRequest.notify(request);
  }

  /*
    * handle the notification sent by FDT
    */
  _handleNotification(json: any) {
    var notificationType = json.method;
    console.log("_handleNotification {} ", json)
    if (notificationType === "connection_status") {
      let errorCode = json.params?.code;
      if(errorCode !== undefined) {
        this.checkFDRSErrorCodes(json.params?.code);
      }
      this._handleConnectionNotification(json.params);
      this.setSystemSnapShotDetails(json.params);
      this.getDataCollectorInformation(json.params.dcModes);
      localStorage.setItem("systemSnapshot", JSON.stringify(json.params));
    }
    else if (notificationType === "message_logged") {
      this._handleLogMessage(json);
    }
    else if (notificationType === "application_queue_finished") {
      this._handleApplicationQueueFinished(json.params);
    }
    else if (notificationType === "network_test_update") {
      this._handleNetworkTestUpdate(json);
    }
    else if (notificationType === "vin_result") {
      this._handleGetVinNotification(json);
    }
    else if ($.inArray(notificationType, this.fdtScreennotificationTypes) >= 0) {
      this._handleScreenNotification(json);
    }
  }

  checkFDRSErrorCodes(errorCode:string) {
    if(errorCode == '-32012') {
      if(this.userType == 'FORD_INTERNAL') {
        this.service.fdrsErorCode.next('Connection failed. The Secured Token from PTS is for a different environment. Please update the system properties and try again.')
      } else if(this.userType == 'PTS_DEALER') {
        this.service.fdrsErorCode.next('FDRS is configured to use a different FDSP endpoint, please ensure latest Production FDRS is installed')
      }
    }
  }

  setSystemSnapShotDetails(params: any) {
    let req = {
      "sessionid": localStorage.getItem("sessionID"),
      "fdrsVersion": params.fdrsVersion,
      "javaVersion": params.javaVersion,
      "firmwareVersioninVCM": params.vcmVersion,
      "firmwareVersioninVMM": params.vmmVersion,
      "osversion": params.operatingSystemVersion,
      "memoryinfo": params.memoryInfo,
      "osname": params.operatingSystemName,
      "cpuinfo": params.cpuInfo,
      "deviceserialnumber": params.deviceSerialNumber
    }
    this.service.setSystemSnapShotDetails(req).subscribe((data) => {
      console.log('----FDRS Connected UPdated Version Number RPC CLIENT-------', data);
    })
  }

  getDataCollectorInformation(params: any) {
    console.log('DC MODES----------------------', params);
    if(params.includes('SKIP_SPECIFIC')) {
      this.service.dataCollectorInfo.next('SKIP_SPECIFIC');
      this.service.showDataCollectorCheckBox.next(true);
    } else {
      this.service.dataCollectorInfo.next('FULL');
      this.service.showDataCollectorCheckBox.next(false);
    }
  }

  /**
    * handle network test update
  */
  _handleNetworkTestUpdate(json: any) {
    this.network_test_update.setCurrentModule(json.params.moduleName);
    this.network_test_update.setPercentage(json.params.moduleNumber / json.params.totalModules * 100);
  }

  /**
    * handle log notifications from FDT
  */
  _handleLogMessage(json: any) {
    this.deferredLogState.notify(json);
  }

  /*
    * Handle the connection type of notifications
  */
  _handleGetVinNotification(json: any) {
    this.deferredGetVinResult.notify(json);
  }

  getQueue() {

    return new Applicationqueue(this);


    // return this.applicationQueue;
    // if (this.queue == null) {
    //   //this.queue = new ApplicationQueue(self); // ???
    // }
    // return this.queue;
  }

  /**
   * handle screen notifications from FDT
   */
  _handleScreenNotification(json: any) {
    // this.getQueue().changeExitButtonState(json.params);  // ???
    this.deferredFDTScreenNotification.notify(json);
  }

  /*
  * Handle the connection type of notifications
  */
  _handleConnectionNotification(params: any) {
    if (params.status === this.status.SUCCESS) {
      // use api later ???
      // new VersionChecker().checkCompatibility(params.fdrsVersion, this._handleCompatibilityCheck);
      this.fdrsVersionCheckerService.checkCompatibility(params.fdrsVersion, this._handleCompatibilityCheck, this);
      // success case
      //this._handleCompatibilityCheck(true, "");
    }
    else if (params.status === this.status.STALL) {
      this.loggedIn = true;
      this.deferredloginState.notify(params.code, params.message);
    }
    else {
      this._handleError("Initial websocket login failed! ", params.code, params.message);
      // check later ???
      // parseInt(params.code) === errorCode.cookieExpired ?
      //     dialogHelper.showYESNOModalMessage({key: "fdt.connection.expired.cookie"}, "", function () { logout(); $SBDOWS(this).dialog("close") }) :
      //     dialogHelper.showModalMessage(params.message, "");

      this.deferredloginState.reject();
      this.close();
    }
  }


  _handleCompatibilityCheck(compatibilityFlag: boolean, message: any, rpcClient: RpcClientService) {
    if (compatibilityFlag) {
      //login  was successful
      rpcClient.loggedIn = true;
      rpcClient.deferredloginState.resolve();
    }
    else {
      if (typeof message !== 'undefined') {
        // check later ???
        console.log(typeof (message))
        console.log('dialog called:', message);
        rpcClient.service.isShowFDRSVersionInCompatableMsg.next({
          'showPopup': true,
          'minimumVersion': message
        })
      }
      rpcClient._setConnectionStatus(rpcClient.connectionStatus.INCOMPATIBLE);
      rpcClient.deferredConnState.notify(rpcClient.connectionStatus.INCOMPATIBLE);
      rpcClient.deferredloginState.reject();
      console.log('close 3');
      rpcClient.close();
    }
  }


  /**
    * handle application queue finished.
    */
  _handleApplicationQueueFinished(params: any) {
    //$SBDOWS(window).unbind('beforeunload'); ???
    let PreviouScreen: string = '';
    this.previousScreenSubscription = this.service.navigatePreviousScreen.subscribe((data) => {
      PreviouScreen = data;
      if (data == 'diagnosticProcedure') {
        this.candidateType = 'DIAGNOSTIC';
      } else if (data == 'repairProcedure') {
        this.candidateType = 'REPAIR'
      } else if (data == 'postRepairProcedure') {
        this.candidateType = 'POST_REPAIR'
      }
    })
    console.log("<!-------------PARAMS---------------", params);


    if (typeof params.success !== "undefined" && params.success !== null) {
      var success = params.success === "true";

      if (params.applicationType == "DiagnosticTest") {
        if (success) {
          if (params.hasOwnProperty('applicationFeedbackSubmitted')) {
            if (params.applicationFeedbackSubmitted == 'true') {
              this.getSuccessOTXStatus(params, PreviouScreen);
            } else if (params.applicationFeedbackSubmitted == 'false') {
              this.getApplicationSubmitSuccessStatus(params, PreviouScreen);
            }

          } else {
            this.getSuccessOTXStatus(params, PreviouScreen);
          }
        }
        else {
          if (params.hasOwnProperty('applicationFeedbackSubmitted')) {
            if (params.applicationFeedbackSubmitted == 'true') {
              this.getFailureOTXStatus(params, PreviouScreen)
            } else if (params.applicationFeedbackSubmitted == 'false') {
              this.getAppliationSubmitFailureStatus(params, PreviouScreen);
            }
          } else {
            this.getFailureOTXStatus(params, PreviouScreen)
          }
        }
      }

      if (params.applicationType === "VehicleID") {
        console.log("getting vehcile Id as application type");
        this._handleNetworkTestFinish(success, params);
      }
    }
    else {
      console.log("Application finished with unknown result.");
    }
  }

  //Handle Application Submit Failure - No Fault, Fail, (Abort when blank OTX)
  getApplicationSubmitSuccessStatus(params: any, PreviouScreen: any) {
    console.log("ger application submit success method called")
    this.deferredApplicationQueue.notify("finished", params);
    this.apiService.showOtxSpinner.next(true);
    if (params.applicationFeedback.applicationStatus.applicationState.stateResourceProperty == 'vehicle.software.app.state.finished') {
      this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, "FINISHED", false, "").subscribe((data) => {
        this.apiService.showOtxSpinner.next(false);
        if (PreviouScreen == 'diagnosticProcedure') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.isCheckBoxDisable = 'true';
              obj.state = 'Pass - no Fault';
              break;
            }
          }
          let faultFoundobj = {
            "status": 'noFault',
            "isFound": false,
            "faultString": ''
          }
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.service.diagnosticViewFaultFound.next(faultFoundobj);
          this.route.navigate(['/info']);
        } else if (PreviouScreen == 'repairProcedure') {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Tested';
              this.service.repairObj.next(this.repairObj);
              this.route.navigate(['/repairProcedures'])
              break;
            }
          }
        } else {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Tested';
              this.service.postRepairObj.next(this.postRepairObj);
              this.route.navigate(['/postrepairProcedures'])
              break;
            }
          }
        }
      });
    }
    if (params.applicationFeedback.applicationStatus.applicationState.stateResourceProperty == 'vehicle.software.app.state.aborted') {
      console.log("inside if condition for disconnected or aborted")
      this.apiService.showOtxSpinner.next(true);
      this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, "ABORTED", false, "").subscribe((data) => {
        this.apiService.showOtxSpinner.next(false);
        if (PreviouScreen == 'diagnosticProcedure') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.isCheckBoxDisable = 'true';
              obj.state = 'Aborted';
              break;
            }
          }
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.route.navigate(['/info']);

        } else if (PreviouScreen == 'repairProcedure') {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Aborted';
              this.service.repairObj.next(this.repairObj);
              this.route.navigate(['/repairProcedures'])
              break;
            }
          }

        } else {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Aborted';
              this.service.postRepairObj.next(this.postRepairObj);
              this.route.navigate(['/postrepairProcedures'])
              break;
            }
          }
        }
      });
    }
    if (params.applicationFeedback.applicationStatus.applicationState.stateResourceProperty == 'vehicle.software.app.state.skipped') {
      this.apiService.showOtxSpinner.next(true);
      this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, "SKIPPED", false, "").subscribe((data) => {
        this.apiService.showOtxSpinner.next(false);
        if (PreviouScreen == 'diagnosticProcedure') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.isCheckBoxDisable = 'true';
              obj.state = 'Skipped';
              break;
            }
          }
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.route.navigate(['/info']);
        }
      });
    } else if (params.applicationFeedback.applicationStatus.applicationState.stateResourceProperty == 'vehicle.software.app.state.indicted') {
      this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, "INDICTED", false, params.applicationFeedback.applicationStatus.indictedComponentId).subscribe((data) => {
        if (PreviouScreen == 'diagnosticProcedure') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.state = 'fail - Fault found';
              let faultFoundobj = {
                "status": 'fault',
                "isFound": true,
                "faultString": data.candidate.result.component.procref.title
              }
              let userObj = {
                userId: this.userName,
                userType: this.userType,
                languageCode: this.language,
                countryCode: this.country,
                vin: this.vin,
                componentNumber: data.candidate.result.component.procref.uidRef,
                sessionid: this.sessionId
              }
              this.service.passApiResp.next(userObj);
              this.service.diagnosticViewFaultFound.next(faultFoundobj);
              this.service.otxStateChangeObj.next(this.captureOtxStateChange);
              this.service.fromResume.next(false);
              this.service.pageData.next('');
              this.route.navigate(['/info']);
              break;
            }
          }
        } else if (PreviouScreen == 'repairProcedure') {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Tested';
              this.service.repairObj.next(this.repairObj);
              this.route.navigate(['/repairProcedures'])
              break;
            }
          }
        } else {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Tested';
              this.service.postRepairObj.next(this.postRepairObj);
              this.route.navigate(['/postrepairProcedures'])
              break;
            }
          }
        }
      });
    }
  }
  //Handle Application Submit Failure - Abort, Error
  getAppliationSubmitFailureStatus(params: any, PreviouScreen: any) {
    console.log("method called ----->")
    console.log("PARAMS-----",params)
    this.deferredApplicationQueue.notify("failed", params);
    this.apiService.showOtxSpinner.next(true);
    if (params.applicationFeedback.applicationStatus.applicationState.stateResourceProperty == 'vehicle.software.app.state.aborted'||params.applicationFeedback.applicationStatus.applicationState.stateResourceProperty == 'vehicle.software.app.state.vehicle.disconnected') {
      console.log("inside disonnected condition")
      this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, "ABORTED", false, "").subscribe((data) => {
        this.apiService.showOtxSpinner.next(false);
        if (PreviouScreen == 'diagnosticProcedure') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.isCheckBoxDisable = 'true';
              obj.state = 'Aborted';
              break;
            }
          }
          let faultFoundobj = {
            "status": 'noFault',
            "isFound": false,
            "faultString": ''
          }
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.service.diagnosticViewFaultFound.next(faultFoundobj);
          this.route.navigate(['/info']);
          this.deferredApplicationQueue.notify("aborted", params);
        } else if (PreviouScreen = 'repairProcedure') {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              obj.result.state = 'Aborted';
              this.service.repairObj.next(this.repairObj);
              this.route.navigate(['/repairProcedures'])
              break;
            }
          }
        } else {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              obj.result.state = this.otxStatusRes.otxStatus;
              this.service.postRepairObj.next(this.postRepairObj);
              this.route.navigate(['/postrepairProcedures']);
              break;
            }
          }
        }
      });
    }
    if (params.applicationFeedback.applicationStatus.applicationState.stateResourceProperty == 'vehicle.software.app.state.error') {
      this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, "ERROR", false, "").subscribe((data) => {
        if (PreviouScreen == 'diagnosticProcedure') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              obj.isCheckBoxDisable = 'true';
              obj.state = data.otxStatus;
              let faultFoundobj = {
                "status": 'noFault',
                "isFound": false,
                "faultString": ''
              }
              var diagError = {
                'ScreenName': 'diagnosticProcedure',
                'reason': params.errorReason,
              }
              this.service.showOTXErrorPopUp.next(diagError);
              this.service.diagnosticViewFaultFound.next(faultFoundobj);
              this.service.otxStateChangeObj.next(this.captureOtxStateChange);
              this.service.fromResume.next(false);
              this.service.pageData.next('');
              break;
            }
          }
        } else if (PreviouScreen == 'repairProcedure') {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********repairError', obj);
              obj.result.state = data.otxStatus
              var repairError: any = {
                'ScreenName': 'repairProcedure',
                'reason': params.errorReason,
              }
              this.service.repairObj.next(this.repairObj);
              this.service.showOTXErrorPopUp.next(repairError);
              break;
            }
          }
        } else {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              obj.result.state = data.otxStatus
              var postRepairError = {
                'ScreenName': 'postRepairProcedure',
                'reason': params.errorReason,
              }
              this.service.postRepairObj.next(this.postRepairObj);
              this.service.showOTXErrorPopUp.next(postRepairError);
              break;
            }
          }
        }
      });
    }
  }

  //Handle_Queue_finished params returns success
  getSuccessOTXStatus(params: any, PreviouScreen: any) {
    this.deferredApplicationQueue.notify("finished", params);
    this.apiService.showOtxSpinner.next(true);
    this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, null, true, null).subscribe((data) => {
      this.otxStatusRes = data;
      this.apiService.showOtxSpinner.next(false);
      console.log("OTX Status:", this.otxStatusRes);
      if (PreviouScreen == 'diagnosticProcedure') {
        if (this.otxStatusRes.otxStatus == "Pass-nofaultfound") {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.isCheckBoxDisable = 'true';
              obj.state = 'Pass - no Fault';
              break;
            }
          }
          let faultFoundobj = {
            "status": 'noFault',
            "isFound": false,
            "faultString": ''
          }
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.service.diagnosticViewFaultFound.next(faultFoundobj);
          this.route.navigate(['/info']);
        }
        else if (this.otxStatusRes.otxStatus == 'Aborted') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.isCheckBoxDisable = 'true';
              obj.state = 'Aborted';
              break;
            }
          }
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.route.navigate(['/info']);
        }
        else if (this.otxStatusRes.otxStatus == 'Skipped') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.isCheckBoxDisable = 'true';
              obj.state = 'Skipped';
              break;
            }
          }
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.route.navigate(['/info']);
        } else if (this.otxStatusRes.otxStatus == 'IndictedComponents Details are Missing') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.isCheckBoxDisable = 'true';
              obj.state = 'IndictedComponents Details are Missing';
              break;
            }
          }
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.route.navigate(['/info']);
        } else if (this.otxStatusRes.otxStatus == 'Fail-faultfound') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.state = 'fail - Fault found';
              let faultFoundobj = {
                "status": 'fault',
                "isFound": true,
                "faultString": this.otxStatusRes.candidate.result.component.procref.title
              }
              let userObj = {
                userId: this.userName,
                userType: this.userType,
                languageCode: this.language,
                countryCode: this.country,
                vin: this.vin,
                componentNumber: this.otxStatusRes.candidate.result.component.procref.uidRef,
                sessionid: this.sessionId
              }
              this.service.passApiResp.next(userObj);
              this.service.diagnosticViewFaultFound.next(faultFoundobj);
              this.service.otxStateChangeObj.next(this.captureOtxStateChange);
              this.service.fromResume.next(false);
              this.service.pageData.next('');
              this.route.navigate(['/info']);
              break;
            }
          }
        }
        if (this.otxStatusRes.otxStatus === null) {
          let diagError = {
            'ScreenName': 'diagnosticProcedure',
            'reason': 'technicalproblem',
            'gnumber': this.selectedAppId
          }
          let faultFoundobj = {
            "status": 'noFault',
            "isFound": false,
            "faultString": ''
          }
          this.service.showOTXErrorPopUp.next(diagError);
          this.service.diagnosticViewFaultFound.next(faultFoundobj);
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
          this.route.navigate(['/info']);
        }
      }
      if (PreviouScreen == 'repairProcedure') {
        if (this.otxStatusRes.otxStatus == "Pass-nofaultfound" || this.otxStatusRes.otxStatus == "Fail-faultfound") {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Tested';
              break;
            }
          }
        }
        else if (this.otxStatusRes.otxStatus == "Aborted") {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Aborted';
              break;
            }
          }
        }  else {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              if (this.otxStatusRes.otxStatus !== null) {
                console.log('********repairError', obj);
                obj.result.state = 'Error';
                break;
              } else {
                break;
              }
            }
          }
          if (this.otxStatusRes.otxStatus === null) {
            let repairError = {
              'ScreenName': 'repairProcedure',
              'reason': 'technicalproblem',
              'gnumber': this.selectedAppId
            }
            this.service.showOTXErrorPopUp.next(repairError);
          }
        }
        this.service.repairObj.next(this.repairObj);
        this.route.navigate(['/repairProcedures'])
      }
      if (PreviouScreen == 'postRepairProcedure') {
        if (this.otxStatusRes.otxStatus == "Pass-nofaultfound" || this.otxStatusRes.otxStatus == "Fail-faultfound") {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Tested';
              break;
            }
          }
        }
        else if (this.otxStatusRes.otxStatus == "Aborted") {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              console.log('********', obj);
              obj.result.state = 'Aborted';
              break;
            }
          }
        } else {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              if (this.otxStatusRes.otxStatus !== null) {
                console.log('********postRepairError', obj);
                obj.result.state = 'Error';
                break;
              } else {
                break;
              }
            }
          }
          if (this.otxStatusRes.otxStatus === null) {
            let postRepairError = {
              'ScreenName': 'postRepairProcedure',
              'reason': 'technicalproblem',
              'gnumber': this.selectedAppId
            }
            this.service.showOTXErrorPopUp.next(postRepairError);
          }
        }
        this.service.postRepairObj.next(this.postRepairObj);
        this.route.navigate(['/postrepairProcedures'])
      }
    }, (error) => {
      console.log("otx status API error:", error)
      if (PreviouScreen == 'diagnosticProcedure') {
        this.route.navigate(['/info'])
      } else if (PreviouScreen == 'repairProcedure') {
        this.route.navigate(['/repairProcedures'])
      } else if (PreviouScreen == 'postRepairProcedure') {
        this.route.navigate(['postrepairProcedures'])
      }
    });
  }

  //Handle_Queue_finished params returns failure
  getFailureOTXStatus(params: any, PreviouScreen: any) {
    this.deferredApplicationQueue.notify("failed", params);
    //FDRS Closed when during network test. //check
    if (params.errorState === this.errorState.ANOTHER_APP_ACTIVE) { // when Another OTX instance is running when clicking on test button we have to show popup.
    this.Another_App_Active = true;
    this.service.show_Another_App_Active_popup.next('true');
    console.log("================ANOTHER APP ACTIVE================================", params);
    }
    else if (params.errorState === this.errorState.ABORTED) {
      if(this.Another_App_Active) {
          this.Another_App_Active = false;
          this.service.show_Another_App_Active_popup.next('false');
          this.startApplication(this.Start_Application_Params);
      } else {
        this.apiService.showOtxSpinner.next(true);
      setTimeout(() => {
        this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, null, true, null).subscribe((data) => {
          this.otxStatusRes = data;
          this.apiService.showOtxSpinner.next(false);
          if (PreviouScreen == 'diagnosticProcedure') {
            for (let obj of this.captureOtxStateChange) {
              if (obj.procUidRef == this.selectedAppId) {
                if (this.otxStatusRes.otxStatus !== null && this.otxStatusRes.otxStatus == 'Aborted') {
                  console.log('********', obj);
                  obj.isCheckBoxDisable = 'true';
                  obj.state = this.otxStatusRes.otxStatus;
                  break;
                }
              }
            }
            let faultFoundobj = {
              "status": 'noFault',
              "isFound": false,
              "faultString": ''
            }
            if (this.otxStatusRes.otxStatus === null) {
              let diagError = {
                'ScreenName': 'diagnosticProcedure',
                'reason': 'technicalproblem',
                'gnumber': this.selectedAppId
              }
              this.service.showOTXErrorPopUp.next(diagError);
            }
            this.service.otxStateChangeObj.next(this.captureOtxStateChange);
            this.service.fromResume.next(false);
            this.service.pageData.next('');
            this.service.diagnosticViewFaultFound.next(faultFoundobj);
            this.route.navigate(['/info']);
            console.log('aborted state:', data);

            // When clicking the cross button
            console.log("abort called ***************")
            this.deferredApplicationQueue.notify("aborted", params);
          }
          if (PreviouScreen == 'repairProcedure') {
            for (let obj of this.repairObj) {
              if (obj.procRef.procUidRef == this.selectedAppId) {
                if (this.otxStatusRes.otxStatus !== null) {
                  console.log('********repairError', obj);
                  obj.result.state = this.otxStatusRes.otxStatus;
                  break;
                } else {
                  break;
                }
              }
            }
            if (this.otxStatusRes.otxStatus === null) {
              let repairError = {
                'ScreenName': 'repairProcedure',
                'reason': 'technicalproblem',
                'gnumber': this.selectedAppId
              }
              this.service.showOTXErrorPopUp.next(repairError);
            }
            this.service.repairObj.next(this.repairObj);
            this.route.navigate(['/repairProcedures'])
          }
          if (PreviouScreen == 'postRepairProcedure') {
            for (let obj of this.postRepairObj) {
              if (obj.procRef.procUidRef == this.selectedAppId) {
                if (this.otxStatusRes.otxStatus !== null) {
                  console.log('********postRepairError', obj);
                  obj.result.state = this.otxStatusRes.otxStatus;
                  break;
                } else {
                  break;
                }
              }
            }
            if (this.otxStatusRes.otxStatus === null) {
              let postRepairError = {
                'ScreenName': 'postRepairProcedure',
                'reason': 'technicalproblem',
                'gnumber': this.selectedAppId
              }
              this.service.showOTXErrorPopUp.next(postRepairError);
            }
            this.service.postRepairObj.next(this.postRepairObj);
            this.route.navigate(['/postrepairProcedures']);
          }
        }, (error) => {
          console.log("otx status API Abort state error:", error)
          if (PreviouScreen == 'diagnosticProcedure') {
            this.route.navigate(['/info'])
          } else if (PreviouScreen == 'repairProcedure') {
            this.route.navigate(['/repairProcedures'])
          } else if (PreviouScreen == 'postRepairProcedure') {
            this.route.navigate(['postrepairProcedures'])
          }
        });
      }, 5000);
      }

    }
    else if (params.errorState != this.errorState.ABORTED) {
      console.log("error called");
      this.apiService.showOtxSpinner.next(true);
      this.service.getOtxStatus(this.vin, this.selectedAppId, this.language, this.country, this.sessionId, this.userName, this.userType, this.candidateType, null, true, null).subscribe((data) => {
        this.otxStatusRes = data;
        this.apiService.showOtxSpinner.next(false);
        console.log("Error:", data);
        if (PreviouScreen == 'diagnosticProcedure') {
          for (let obj of this.captureOtxStateChange) {
            if (obj.procUidRef == this.selectedAppId) {
              if (this.otxStatusRes.otxStatus !== null && this.otxStatusRes.otxStatus == 'Error') {
                console.log('********', obj);
                obj.isCheckBoxDisable = 'true';
                obj.state = this.otxStatusRes.otxStatus;
                break;
              }
            }
          }
          let faultFoundobj = {
            "status": 'noFault',
            "isFound": false,
            "faultString": ''
          }
          let diagError;
          if (this.otxStatusRes.otxStatus !== null) {
            diagError = {
              'ScreenName': 'diagnosticProcedure',
              'reason': params.errorReason
            }
          } else {
            diagError = {
              'ScreenName': 'diagnosticProcedure',
              'reason': 'technicalproblem',
              'gnumber': this.selectedAppId
            }
          }
          this.service.showOTXErrorPopUp.next(diagError);
          this.service.diagnosticViewFaultFound.next(faultFoundobj);
          this.service.otxStateChangeObj.next(this.captureOtxStateChange);
          this.service.fromResume.next(false);
          this.service.pageData.next('');
        }
        if (PreviouScreen == 'repairProcedure') {
          for (let obj of this.repairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              if (this.otxStatusRes.otxStatus !== null) {
                console.log('********repairError', obj);
                obj.result.state = this.otxStatusRes.otxStatus
                break;
              } else {
                break;
              }
            }
          }
          let repairError;
          if (this.otxStatusRes.otxStatus !== null) {
            repairError = {
              'ScreenName': 'repairProcedure',
              'reason': params.errorReason
            }
          } else {
            repairError = {
              'ScreenName': 'repairProcedure',
              'reason': 'technicalproblem',
              'gnumber': this.selectedAppId
            }
          }
          this.service.repairObj.next(this.repairObj);
          this.service.showOTXErrorPopUp.next(repairError);
        }
        if (PreviouScreen == 'postRepairProcedure') {
          for (let obj of this.postRepairObj) {
            if (obj.procRef.procUidRef == this.selectedAppId) {
              if (this.otxStatusRes.otxStatus !== null) {
                console.log('********postRepairError', obj);
                obj.result.state = this.otxStatusRes.otxStatus
                break;
              } else {
                break;
              }
            }
          }
          let postRepairError;
          if (this.otxStatusRes.otxStatus !== null) {
            postRepairError = {
              'ScreenName': 'postRepairProcedure',
              'reason': params.errorReason
            }
          } else {
            postRepairError = {
              'ScreenName': 'postRepairProcedure',
              'reason': 'technicalproblem',
              'gnumber': this.selectedAppId
            }
          }
          this.service.postRepairObj.next(this.postRepairObj);
          this.service.showOTXErrorPopUp.next(postRepairError);
        }
      }, (error) => {
        console.log("otx status API otx error state:", error)
        if (PreviouScreen == 'diagnosticProcedure') {
          this.route.navigate(['/info'])
        } else if (PreviouScreen == 'repairProcedure') {
          this.route.navigate(['/repairProcedures'])
        } else if (PreviouScreen == 'postRepairProcedure') {
          this.route.navigate(['postrepairProcedures'])
        }
      });
    }
  }
  _handleNetworkTestFinish(success: any, params: any) {
    this.network_test_update.setPercentage(100);
    this.service.isProgressBar.next(false);
    this.service.isNetorkTest.next(true);
    console.log("Network test params:", params)
    console.log("isSuccessNetworkTest:", success)
    if (params.errorState === this.errorState.ANOTHER_APP_ACTIVE) {
      console.log('error n/w finish');
    }
    if (success) {
      console.log('success n/w finish, refreshing topology');
      let obj = {
        "status": true,
        "reason": ""
      }
      this.service.isFDRSNetworkTest$.next(obj)
      this.service.refreshTopology(localStorage.getItem("sessionID")).subscribe((data) => {
        console.log('refresh topology:', data);
      })
    } else {
      let obj = {
        "status": false,
        "reason": params.errorReason
      }
      this.service.isFDRSNetworkTest$.next(obj);
    }

    // ??? - added for testing
    if (params.errorReason) {
      this._networkResult$.next(params.errorReason);
    }

  }

  /*
  the method to handle error code returned from FDT
  */
  _handleError(messageType: any, errorCode: any, errorMessage: any) {
    // see error codes in FDRS JSON RPC document and provide your own messages for user
    // errorMessage is for internal use only (debugging, logging etc.)
    console.error("Error message: messageType=" + messageType + ", errorCode=" + errorCode + ", errorMessage=" + errorMessage);
  }


  runNetworkTest(clientId: any, noSession: any) {
    let dcModeValue: String;
    var ntDef = $.Deferred();
    this.service.tokenObj.subscribe((data) => {

      this.res = data;
      this.invinnumber = this.res.vin
      this.language = this.res.language.toLowerCase()
      this.countryCode = this.res.country
    })

    this.service.dataCollectorInfo.subscribe((data)=> {
       dcModeValue = data;
    })

     // This extra check is related to Data Collector Functionality.
     let sessionIdNumber:any = '';
    if(localStorage.getItem('DCSessionId') == '') {
      sessionIdNumber = localStorage.getItem("sessionID")
    } else {
      sessionIdNumber = localStorage.getItem("DCSessionId")
    }

    // this.getQueueId("NetworkTest", clientId, noSession).then((queueId: any) => {
    this.apiService.userId.subscribe((data) => {
      this.userId = data
    })
    const req = {
      "userId": this.userId,
      "sessionSource": "gfdrs",
      "vin": this.invinnumber,
      "fdrsId": 22
    }
    let reqBodyForSessionId =
    {
      "sessionId": sessionIdNumber
    }

    this.apiService.queueIdRes(this.language, this.countryCode, reqBodyForSessionId, 'NetworkTest', '').subscribe((data) => {
      this.qidRes = data

      var params = {
        "applicationId": "NetworkTest",
        "queueId": this.qidRes,
        "applicationType": "VehicleID",
        "functionType": "NETWORK_TEST",
        "complexTool": "false",
        "dcMode": dcModeValue
      };
      console.log("----------Network test params------------", params);
      this.startApplication(params);
      this.network_test_update.setCurrentModule(null);
      ntDef.resolve();

    })
    // var params = {
    //   "applicationId": "NetworkTest",
    //   "queueId": this.queueId,
    //   "applicationType": "VehicleID",
    //   "functionType": "NETWORK_TEST",
    //   "complexTool": "false"
    // };
    // console.log("params",params);
    // this.startApplication(params);
    // this.network_test_update.setCurrentModule(null);
    // ntDef.resolve();

    // }).fail(() => {
    //   ntDef.reject();
    // });

    return ntDef;
  };

  getQueueId(appId: any, clientId: any, noSession: any) {
    var queueDef = $.Deferred();
    clientId = clientId || "GFDRS"; // if not defined then GFDRS type by default
    var url = "/sbdows/servicereception/app/queuedApplicationRequest.do?id=" + appId +
      "&appReady=false&clientId=" + clientId + "&token=" + Date.now() +
      "&installedJREs=notrequired";

    if (typeof noSession !== "undefined" && noSession == true) {
      url += "&noSession=true";
    }

    setTimeout(() => {
      queueDef.resolve(this.queueId);

      //1626946523000VINWF0JXXWPBJAS38295
      //1627286319000VINWF0RXXWPGRHU38253
      //1627286514000VINWF0EXXWPCEFL10444
    }, 500);

    // ??? - implement later
    //this.sbdoApiService.getAppQueueId(appId, clientId);

    // ??? - add service call later
    //url = addCSRFTokenToURL(url);
    // $SBDOWS.ajax(
    // {
    //     url: EtisSbdoWebService.baseUrl + url,
    //     type: "POST",
    //     crossDomain: true,
    //     headers: {'Authorization': 'Bearer ' + EtisSbdoWebService.token},
    //     xhrFields: {withCredentials: true},
    //     timeout: 120000
    // })
    // .done(function(response)
    // {
    //     var queueIdExp = response.match('id="applicationReadyQueueId">([A-Z0-9]*)<');

    //     if (queueIdExp && queueIdExp.length > 1)
    //     {
    //         queueDef.resolve(queueIdExp[1]);
    //     }
    //     else
    //     {
    //         queueDef.reject();
    //     }
    // })
    // .fail(function()
    // {
    //     queueDef.reject();
    // });


    return queueDef;
  }


  startApplication(params: any) {
    var jsonToSend = {
      "method": "start_application_queue",
      "params": params
    };
    console.log("application start",jsonToSend)
    this.Start_Application_Params = params;
    this.selectedAppId = params.applicationId;
    this.sessionId = localStorage.getItem("sessionID")
    this.getSelectedDiagnosticProcedureDetails();
    this.getSelectedRepairProcedureDetails();
    this.getSelectedPostRepairProcedureDetails()
    console.log('start Application Params:', params.applicationId);
    //make the call
    this.sendMessageToFDT("startApplicationQueue", jsonToSend, (response: any) => {
      console.log("Requested run queued application with response " + response.status);

      if (response.status == this.status.FAILURE) {
        //dialogHelper.showModalMessage(response.responseData.errorMsg, ""); ???
        this.deferredAppReady.reject();
      }
      else {
        // ???
        // $SBDOWS(window).bind("beforeunload",function()
        // {
        //     return $SBDOWS.message('vehicle.software.app.state.running');
        // });
        if (params.applicationId !== 'NetworkTest') {
          console.log("otx candidate popup called", params)
          this.deferredAppReady.resolve(params);
          setTimeout(() => { this.deferredApplicationQueue.notify("start", params); }, 500);

        }
      }
    });
  };

  getSelectedDiagnosticProcedureDetails() {
    this.service.otxStateChangeObj.subscribe((data) => {
      this.captureOtxStateChange = data;
      console.log("captureStateChange:", this.captureOtxStateChange);
    })
  }

  getSelectedRepairProcedureDetails() {
    this.service.repairObj.subscribe((data) => {
      this.repairObj = data;
      console.log("-------repair Obj------", this.repairObj);
    })
  }

  getSelectedPostRepairProcedureDetails() {
    this.service.postRepairObj.subscribe((data) => {
      this.postRepairObj = data;
      console.log("-------post repair Obj------", this.postRepairObj);
    })
  }

  //endpoints
  bootstrap(callbackFunction: any) {
    var jsonToSend = {
      "method": "get_fdt_scripts"
    };
    //make the call
    this.sendMessageToFDT("GET_FDT_SCRIPTS", jsonToSend, callbackFunction);
  };

  /*
    the method to make the websocket call with message type, data, parameters and callback function.
  */
  sendMessageToFDT(msgType: any, payloadjson: any, callbackFunction: any) {
    var messageId = this._getNextMessageId(msgType);
    this._storeMessageReturnFunction(messageId, callbackFunction);

    var jsonReqObj = this._createReqJson(messageId, payloadjson);

    try {
      //console.log('sending message to fdrs for ', msgType, ' with json ', JSON.stringify(jsonReqObj));
      this._sendmessageToFdt(jsonReqObj);
    }
    catch (exception: any) {
      console.error("Unable to send message to websocket: " + exception.message);

      var response = {
        status: this.status.FAILURE,
        responseData: { "errorMsg": exception.userMessage }
      };

      callbackFunction(response);
    }
  };


  /*
  Get the message type form the message ID
  */
  _getMessageType(messageId: any) {
    var messagetype = messageId.split("~!~")[0];

    return messagetype;
  }

  /*
  the method to get a unique id madeup of a number + date + user(if logged in)
  */
  _getNextMessageId(msg_type: any) {
    ++this.nextMessageId;
    return msg_type + "~!~" + this.nextMessageId + "~!~" + Math.floor(Date.now() / 1000) + this.user;
  }

  /*
    the method to set message  callback function for message ID
  */
  _storeMessageReturnFunction(messageId: any, returnFunction: any) {
    this.messageCallbackFunctions[messageId] = returnFunction;
  }

  /*
    the method to get message callback function from the message ID
  */
  _getMessageCallbackFunction(messageId: any) {
    return this.messageCallbackFunctions[messageId];
  }

  /*Create a json object for the request to FDT
     */
  _createReqJson(messageId: any, payloadjson: any) {
    payloadjson.jsonrpc = '2.0';
    payloadjson.id = messageId;

    return JSON.stringify(payloadjson);
  }


  /**
   * send message to fdrs via websocket
   */
  _sendmessageToFdt(jsonReqObj: any) {
    if (this.webSocket != null && this.webSocket.readyState === 3) {
      //FDRS Closed when during network test.
      //this.close();
      throw new ConnectionException("Websocket connection is closed.", { key: 'fdrs.state.not.connected' });
    }

    if (this.getConnectionStatus() == this.connectionStatus.FAILED || this.getConnectionStatus() == this.connectionStatus.CLOSED) {
      throw new ConnectionException("Websocket connection is not established.", { key: 'fdrs.state.not.connected' });
    }
    else if (this.getConnectionStatus() == this.connectionStatus.CONNECTED) {
      if (!this.loggedIn) {
        throw new ConnectionException("User is not logged in.", { key: 'fdrs.state.not.connected' });
      }
      //console.log("_sendMsg:", jsonReqObj);
      this.webSocket.send(jsonReqObj);
    }
    else if (this.getConnectionStatus() == this.connectionStatus.INCOMPATIBLE) {
      this.close();
      throw new ConnectionException("Gfdrs version is not compatible.", { key: 'fdrs.state.not.connected' });
    }
    else {
      throw new ConnectionException("Websocket connection is in progress.", { key: 'fdrs.state.connecting' });
    }
  }

  /*
  function to close the websocket.
  */
  close() {
    this.webSocket.close(1000, "Connection closed!");
    this.hideFDRSIndicator();
    console.log("FDRS connection closed!");
    this.service.isShowFDRSLoader.next(false);
    this.service.isFDRSConnection.next(false);
    /*--Resetting system snapshot information when FDRS Disconnected --*/
    this.resettingSnapshotData()
    this._resetLocalStorage();
    this.deferredConnState.reject(this.connectionStatus.CLOSED);
  };

  resettingSnapshotData() {
    let req = {
      "sessionid": localStorage.getItem("newSessionID"),
      "fdrsVersion": "unknown",
      "javaVersion": "unknown",
      "firmwareVersioninVCM": "unknown",
      "firmwareVersioninVMM": "unknown",
      "osversion": "unknown",
      "memoryinfo": "unknown",
      "osname": "unknown",
      "cpuinfo": "unknown",
      "deviceserialnumber": "unknown"
    }
    localStorage.setItem("systemSnapshot", JSON.stringify(req));
  }

  hideFDRSIndicator() {
    this.apiService.fdrsConnectionIndicator.next('hide');
    this.service.isShowFDRSLoader.next(false);
    console.log('hideFDRSIndicator');
  }

  /* store connection state in localstorage.
      */
  _setConnectionStatus(connectionState: any) {
    window.localStorage.setItem(this.CONNECTION_STATE, connectionState);
  }

  /* get connection state from localstorage.
  */
  getConnectionStatus() {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | number | null' is not a... Remove this comment to see the full error message
    return parseInt(window.localStorage.getItem(this.CONNECTION_STATE) == null ? this.connectionStatus.CLOSED : window.localStorage.getItem(this.CONNECTION_STATE), 10);
  };

  /*
  extracts the port from the URL
  */
  _getPortFromUrl(url: string) {
    var portExpr = /\:(\d+)\/\?/g;
    var matches = portExpr.exec(String(url));
    //@ts-ignore
    return parseInt(matches[1], 10);
  }

  setKeepAliveInterval() {
    var that = this;

    this.keepAliveHandler = setInterval(() => {
      var jsonToSend = {
        "method": "keep_alive",
        "params": {}
      };
      //make the call
      that.sendMessageToFDT("keep_alive", jsonToSend, (response: any) => {
        console.log('keep alive callback, response ', response);
        if (!response || response.status !== that.status.SUCCESS) {
          //$SBDOWS('#applicationStatusDiv').hide();  -- ??? - see equivalent later
        }
      });
    }
      , that.KEEP_ALIVE_INTERVAL);
  }

  checkFDRSConnectionStatustoDownloadLogs() {
    var that = this;
    var jsonToSend = {
      "method": "keep_alive",
      "params": {}
    };

    that.sendMessageToFDT("keep_alive", jsonToSend, (response: any) => {
      if (response.status == that.status.SUCCESS) {
        this.apiService.fdrsConnectionStatus.next(true);
      } else {
        this.apiService.fdrsConnectionStatus.next(false)
      }
    })
  }

  checkFDRSConnectionStatus() {
    var that = this;

    var jsonToSend = {
      "method": "keep_alive",
      "params": {}
    };
    //make the call
    that.sendMessageToFDT("keep_alive", jsonToSend, (response: any) => {
      //console.log('keep alive callback, response ', response);
      if (!response || response.status !== that.status.SUCCESS) {
        //$SBDOWS('#applicationStatusDiv').hide();  -- ??? - see equivalent later
        if (localStorage.getItem("component") == 'fromStartup') {
          this.service.getWebsocketStatusonStartUpComp.next('false')
        } else if (localStorage.getItem("component") == 'fromDiagnostic' || localStorage.getItem("component") == 'fromRepair' || localStorage.getItem("component") == 'fromPostRepair') {
          this.service.getFDRSStatusInDiagnostic.next('false')
        } else if (localStorage.getItem("component") == 'fromNetworkTest') {
          this.service.getWebsocketStatus.next('false')
        }
        this.hideFDRSIndicator();
      } else if (response.status == that.status.SUCCESS) {
        if (localStorage.getItem("component") == 'fromStartup') {
          this.service.getWebsocketStatusonStartUpComp.next('true')
        } else if (localStorage.getItem("component") == 'fromDiagnostic' || localStorage.getItem("component") == 'fromRepair' || localStorage.getItem("component") == 'fromPostRepair') {
          this.service.getFDRSStatusInDiagnostic.next('true')
        } else if (localStorage.getItem("component") == 'fromNetworkTest') {
          this.service.getWebsocketStatus.next('true')
        }
      }
    });
  }

  HideFDRSIconIfNotConnected() {
    var that = this;

    var jsonToSend = {
      "method": "keep_alive",
      "params": {}
    };
    //make the call
    that.sendMessageToFDT("keep_alive", jsonToSend, (response: any) => {
      console.log('keep alive callback, response ', response);
      if (!response || response.status !== that.status.SUCCESS) {
        this.hideFDRSIndicator();
        this.resettingSnapshotData();
      }
    })
  }

  /* clean localstorage.
     */
  _resetLocalStorage() {
    //window.localStorage.setItem( this.CONNECTION_STATE, this.connectionStatus.CLOSED); ??? - replaced with below
    this._setConnectionStatus(this.connectionStatus.CLOSED);

    // window.localStorage.removeItem( AUTH_TOKEN);

    // window.clearInterval(this.keepAliveHandler);  ??? - uncomment later
    clearInterval(this.keepAliveHandler);

    // Dont clear the port as it will be required for future connections
    //window.localStorage.removeItem( FDT_PORT);
  }

  /*
      the method to make the websocket call with message response to an FDRS request.
     */
  sendResponseToFDT(jsonToSend: any) {
    console.log("responetoFDT 5 ")
    var jsonRequest = JSON.stringify(jsonToSend);

    if (this.validatePayload(jsonToSend)) {
      try {
        this._sendmessageToFdt(jsonRequest);
        return true;
      }
      catch (exception: any) {
        console.error("Failed to send response to FDRS. Json tried: " + jsonRequest + ". Error: " + exception.message);
      }
    }
    else {
      console.error("Response Json is not valid! Json being sent: " + jsonRequest);
    }

    return false;
  };

  /**
  * validate jsonToSend for id and jsonrpc version and method
  *
  */
  validatePayload(jsonToSend: any) {
    return jsonToSend.jsonrpc != undefined && jsonToSend.jsonrpc !== ''
      && jsonToSend.id != undefined && jsonToSend.id !== ''
      && jsonToSend.method != undefined && jsonToSend.method !== '';
  }

  abortApplication() {
    var jsonToSend = {
      "method": "abort_application_queue",
      "params": {}
    };
    //make the call
    this.sendMessageToFDT("abortApplicationQueue", jsonToSend, (response: any) => {
      console.log("Requested abort queued application with response " + response.status);

      if (response.status === this.status.FAILURE) {
        console.log("Abort Application: FAILED");
        //  dialogHelper.showModalMessage(response.responseData.errorMsg, "");
      }
      else {
        console.log("application queue aborted");
      }
    });
  };

  ngOnDestroy() {
    this.previousScreenSubscription.unsubscribe();
  }
}

/**
* Connection exception class to handle connectivity issues.
*
* @param message
* @param userMessage
* @constructor
*/
export class ConnectionException {
  constructor(private message: any, private userMessage: any) {
    this.message = message;
    this.userMessage = typeof userMessage === 'undefined' ? null : userMessage;
  }
}
